import React from "react";

const Main = ({ children }) => {
  return <React.Fragment>{children}</React.Fragment>;
};

export default Main;
